// const REACT_TOAST_LONG_TIME = 10000;

export const toastConfig = {
  // Time to display longer toast messages
  // REACT_TOAST_LONG_TIME,  this is not being used anywhere

  // TODO: I think we should disable the toast messages
  drawMessagesEnabled: true,
};
